import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { EmployeeData, useEmployee } from '../../../services/api/employees'
import { AsyncStates } from '../../../components'
import { BackButton } from '../../../components'
import { Divider, Space } from 'antd'
import { Card } from './Card'

const Show: React.FunctionComponent = () => {
  const { id } = useParams()
  const [getEmployee, { isLoading, response, error }] = useEmployee(id)

  useEffect(() => {
    getEmployee()
  }, [getEmployee])

  return (
    <>
      <h2> Профиль сотрудника </h2>

      <AsyncStates<EmployeeData>
        isLoading={isLoading}
        error={error}
        errorMessage="Не удалось загрузить карточку компании"
        reload={() => getEmployee()}
        response={response}
        renderData={(employee) => (
          <>
            <Card employee={employee} />
            <Divider />
            <Space>
              <BackButton />
            </Space>
          </>
        )}
      />
    </>
  )
}

export default Show
